module.exports = __webpack_public_path__ + "static/media/accessory4.65cb135a.webp";